import { c as _c } from "react/compiler-runtime";
import { UsercentricsDialogToggle } from '@s-group/react-usercentrics';
import { Fragment } from 'react';
import { Link } from '#components/Link/Link';
import type { NavigationTreeLeaf } from '#cutils/page-context/navigation';
import { IconSystem } from '#icons/IconSystem';
import styles from './BRLinks.module.scss';
import { brLinks, impressumLinks } from './Footer.utils';
function isUsercentricsNode(node: NavigationTreeLeaf | {
  id: string;
  title: string;
  type: 'usercentrics';
}): node is {
  id: string;
  title: string;
  type: 'usercentrics';
} {
  return (node as any)['type'] === 'usercentrics';
}
type Props = {
  className?: string;
};
export function BRLinks(t0) {
  const $ = _c(4);
  const {
    className
  } = t0;
  const t1 = `${styles.section} ${className ?? ""}`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className={styles.brLinks}>{brLinks.map(_temp)}</div>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className={styles.impressum}>{impressumLinks.map(_temp2)}</div>;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t1) {
    t4 = <section className={t1}>{t2}{t3}</section>;
    $[2] = t1;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  return t4;
}
function _temp2(node, index) {
  if (isUsercentricsNode(node)) {
    return <Fragment key={node.id}><UsercentricsDialogToggle className={`${styles.link} button-link no-focus`}><span className={styles.linkTitle}>{node.title}</span><IconSystem className={styles.icon} icon="next" variant="filled" aria-hidden={true} /></UsercentricsDialogToggle>{index < impressumLinks.length - 1 ? <span className={styles.divider} aria-hidden="true">|</span> : null}</Fragment>;
  } else {
    const {
      link,
      isExternal,
      id,
      title: title_0
    } = node;
    return <Fragment key={id}><Link className={`${styles.link} no-focus`} href={link} target={isExternal ? "_blank" : undefined}><span className={styles.linkTitle}>{title_0}</span><IconSystem className={styles.icon} icon="next" variant="filled" aria-hidden={true} /></Link>{index < impressumLinks.length - 1 ? <span className={styles.divider} aria-hidden="true">|</span> : null}</Fragment>;
  }
}
function _temp(t0) {
  const {
    url,
    icon,
    title
  } = t0;
  return <Link className="no-focus" href={url} target="_blank" key={url} aria-label={title}><IconSystem icon={icon} variant="filled" size="xl" title={title} /></Link>;
}